import { GET_USER_INFO_REQUEST, GET_USER_INFO_SUCCESS, GET_USER_INFO_FAILURE } from "../../actions";
const initialState = {
    map: {},
    loadingIds: {},
    failedIds: {},
};
const getUserInfoReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_USER_INFO_REQUEST:
            return Object.assign(Object.assign({}, state), { loadingIds: Object.assign(Object.assign({}, state.loadingIds), { [action.payload.userId]: true }) });
        case GET_USER_INFO_SUCCESS:
            return Object.assign(Object.assign({}, state), { map: Object.assign(Object.assign({}, state.map), { [action.payload.userId]: action.payload.data }), loadingIds: Object.assign(Object.assign({}, state.loadingIds), { [action.payload.userId]: false }) });
        case GET_USER_INFO_FAILURE:
            return Object.assign(Object.assign({}, state), { loadingIds: Object.assign(Object.assign({}, state.loadingIds), { [action.payload.userId]: false }), failedIds: Object.assign(Object.assign({}, state.failedIds), { [action.payload.userId]: true }) });
        default:
            return state;
    }
};
export default getUserInfoReducer;
